import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from './config.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { AiBannerComponent } from '../admin/aiBanner/ai-banner-component';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private showBannerSubject = new BehaviorSubject<boolean>(false);
  public showBanner$ = this.showBannerSubject.asObservable();

  constructor(
    public config: ConfigService,
    private dialog: MatDialog,
  ) {}

  /**
   * Check if banner should be displayed
   * @returns true if banner should be shown
   */
  shouldShowBanner(): boolean {
    return !!this.config.appConfig.setup.enableAIBanner;
  }

  checkAndShowBanner(): void {
    const shouldShow = this.shouldShowBanner();
    this.showBannerSubject.next(shouldShow);

    if (shouldShow) {
      this.openBannerModal();
    }
  }

  /**
   * Open the AI banner modal
   */
  private openBannerModal(): void {
    const dialogRef = this.dialog.open(AiBannerComponent, {
      disableClose: false,
      closeOnNavigation: true,
      panelClass: 'ai-banner-dialog',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dismissBanner();
    });
  }

  dismissBanner(): void {
    this.showBannerSubject.next(false);
  }
}
